import { render, staticRenderFns } from "./IntroduceSwiper.vue?vue&type=template&id=53fc6bdb&scoped=true"
import script from "./IntroduceSwiper.vue?vue&type=script&lang=js"
export * from "./IntroduceSwiper.vue?vue&type=script&lang=js"
import style0 from "./IntroduceSwiper.vue?vue&type=style&index=0&id=53fc6bdb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fc6bdb",
  null
  
)

export default component.exports